import SEO from "components/Common/SEO";
import ExternalLink from "components/ExternalLink/ExternalLink";
import Footer from "components/Footer/Footer";
import styled from 'styled-components'
import { USD_DECIMALS, getPageTitle, importImage } from "lib/legacy";
import lockBg from 'img/lockMMY/bg.png';
import bg from "img/earn/bg.svg";
import mmyCircleLogo from 'img/lockMMY/mmy_circle_logo.svg';
import questionMark from 'img/lockMMY/question_mark.svg';
import thunderBolt from 'img/lockMMY/bolt.svg';
import './LockMMY.scss'
import StakeNFT from "./StakeNFT";
import MMYLPOverview from "./MmyLpOverview";
import VestingOverview from "./VestingOverview";
import useLockMMYLPInfo from "hooks/useLockMMYLPInfo";
import Tooltip from "components/Tooltip/Tooltip";
import { FANTOM, getConstant } from "config/chains";
import { useChainId } from "lib/chains";
import { useWeb3React } from "@web3-react/core";
import useUserLockedMMYLP from "hooks/useUserLockedMMYLP";
import { formatAmount } from "lib/numbers";
import { getWrappedToken } from "config/tokens";
import { BigNumber } from "ethers";
import { useGmxPrice } from "domain/legacy";
import { useState } from "react";
import ZapModal from "./ZapModal";
import LockStakeLP from "./LockStakeLP";
const LockMMYLP = ({ setPendingTxns, pendingTxns, connectWallet }) => {
  const { info: lockMMYLpInfo } = useLockMMYLPInfo()
  const { chainId } = useChainId()
  const { account, active, library } = useWeb3React();
  const nativeTokenSymbol = getConstant(chainId, "nativeTokenSymbol");
  const [isZapModalVisible, setIsZapModalVisible] = useState(false);
  const userInfo = useUserLockedMMYLP();
  const { claimableRewards } = userInfo;
  const { gmxPrice } = useGmxPrice(chainId, { arbitrum: chainId === FANTOM ? library : undefined }, active);
  const nativeTokenImage = importImage(`ic_${nativeTokenSymbol?.toLowerCase()}_24.svg`);
  const mmyLPPrice = 1;
  const wrapToken = getWrappedToken(chainId);
  const getWrapRewards = () => {
    if (!claimableRewards || !claimableRewards[1]) return BigNumber.from(0)
    const findTokenReward = claimableRewards.find(x => x.token === wrapToken.address);
    if (findTokenReward) {
      const amount = findTokenReward.amount;
      return amount;
    }
    else return BigNumber.from(0)
  }
  const wrapTokenReward = getWrapRewards();
  return (
    <SEO title={getPageTitle("Lock MMY LP")}>
      <Wrapper>
        <div className="default-container page-layout Referrals LockMMY">
          <div>
            <div
              // style={{
              //   backgroundImage: `url(${lockBg})`,
              // }}
              className="section-title-block"
            >
              <div className="section-title-content">
                <div className="left">
                  <div className="Page-title">
                    <span>Earning MMY LP Real Yield</span>
                  </div>
                  <div className="Page-description">
                    <div>
                      Earn Real Yield by locking MMY LP and Mummy Rebirth NFT.
                    </div>
                  </div>
                  <div>
                    <ExternalLink href="https://docs.mummy.finance/referrals">
                      <button className="App-button-option border-btn">Learn more</button>
                    </ExternalLink>
                  </div>

                </div>
                <div className="right">
                  <div className="square-mark">
                    <img alt="icon" src={questionMark} className="ic-questionmark" />
                    <div className="title">What is MMY LP? <img alt="" src={mmyCircleLogo} /></div>
                    <div className="desc">Provide MMY-FTM (75-25) liquidity on Beethoven to get MMY LP.</div>
                    <button onClick={() => setIsZapModalVisible(true)} className="App-button-option"><span><img alt="" src={thunderBolt} /> Zap into MMY LP</span></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bottom-content-container">
            <div className="total-info-container">
              <div className="info-content-container">
                <div className="info-content">
                  <div className="title">Total {nativeTokenSymbol} Rewards</div>
                  <div className="value">
                    <img src={nativeTokenImage} alt="" /> {formatAmount(lockMMYLpInfo?.lockedSupply || 0, 18, 2, true)} <span>
                      ${formatAmount(lockMMYLpInfo?.lockedSupply?.mul(mmyLPPrice) || 0, 18, 2, true)}
                    </span>
                  </div>
                </div>
                <div className="info-content">
                  <div className="title">APR</div>
                  <div className="value green-value">
                    15,000.86%
                  </div>
                </div>
                <div className="info-content">
                  <div className="title">Total MMY-LP Locked</div>
                  <div className="value">
                    11,55,524
                  </div>
                </div>
                <div className="info-content">
                  <div className="title">Total veMMY-LP Minted</div>
                  <div className="value">
                    11,55,524
                  </div>
                </div>
                <div className="info-content">
                  <div className="title">Total veMMY-LP Staked</div>
                  <div className="value">
                    11,55,524
                  </div>
                </div>
                <div className="divider" />
                <div className="pending-rewards">
                  <div className="pending-content">
                    <div className="info-content">
                      <div className="title">Pending Rewards</div>
                      <div className="value">
                        <img src={nativeTokenImage} alt="" /> {formatAmount(lockMMYLpInfo?.lockedSupply || 0, 18, 2, true)} <span>
                          ${formatAmount(lockMMYLpInfo?.lockedSupply?.mul(mmyLPPrice) || 0, 18, 2, true)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="claim-acion">
                    <button className='App-button-option'>Claim</button>
                  </div>
                </div>
              </div>
            </div>
            <LockStakeLP userInfo={userInfo} setPendingTxns={setPendingTxns} pendingTxns={pendingTxns} connectWallet={connectWallet} />
          </div>
          <ZapModal visible={isZapModalVisible} setIsVisible={setIsZapModalVisible} />
        </div>
      </Wrapper>

      <Footer />
    </SEO>
  )
}
export default LockMMYLP;
const Wrapper = styled.div`
  background-image: url(${bg});
  background-repeat: no-repeat;
  background-size: contain;
`;
